import * as ed from '@noble/ed25519'
import { sha512 } from '@noble/hashes/sha512'
import { base64UrlDecode, base64UrlEncode, deriveKid } from '@secureblob/sdk/workspaceSecretV2'

ed.etc.sha512Sync = (...m) => sha512(ed.etc.concatBytes(...m))
ed.etc.sha512Async = (...m) => Promise.resolve(sha512(ed.etc.concatBytes(...m)))

export interface McpSeedIdentity {
    kid: string
    pk: string
}

export async function deriveMcpSeedIdentity(seedB64: string): Promise<McpSeedIdentity> {
    const seed = base64UrlDecode(seedB64)
    const pk = await ed.getPublicKey(seed)
    return {
        kid: await deriveKid(pk),
        pk: base64UrlEncode(pk),
    }
}
